// extracted by mini-css-extract-plugin
var _1 = "#fa8c16";
var _2 = "#531dab";
var _3 = "#c41d7f";
var _4 = "#08979c";
var _5 = "#188efe";
var _6 = "#08979c";
export { _1 as "appCount", _2 as "picklistCount", _3 as "populationPercentage", _4 as "referenceCount", _5 as "reportCount", _6 as "tagCount" }
